import { render, staticRenderFns } from "./ChartRoulette.vue?vue&type=template&id=35ffd002"
import script from "./ChartRoulette.vue?vue&type=script&lang=js"
export * from "./ChartRoulette.vue?vue&type=script&lang=js"
import style0 from "./ChartRoulette.vue?vue&type=style&index=0&id=35ffd002&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports